import moment from "moment"
import { Modal, Button, Row, Col } from "reactstrap"
import Alerton from '../../assets/img/icons/alerton.svg'
import Bell from '../../assets/img/icons/bell.svg'
import axios from "axios"
import { useDispatch } from "react-redux"
import { updatePatients } from "actions"
import { fixNumAndRemoveDecimalZero } from "utils"
import './doctor-alerts.scss'

export default function DoctorAlerts({ alerts, toggleModal, patient, user, alertsOrRemind, isRealtime }) {
  const dispatch = useDispatch()
  const onConfirm = async (status) => {
    const listId = alerts.map(a => a.alertId)
    try {
      let userId = user?.data?.id
      await axios.post(
        `${process.env.REACT_APP_API_URL}/app/patient/update-alert-status`,
        { id: listId, status, userId },
        { headers: { 'Authorization': `Bearer ${user.jwtToken}` } }
      )
      if (alertsOrRemind === 'remindAlerts' && status === 'remind_later') return toggleModal(false)
      alertsOrRemind === 'alerts' && status === 'remind_later'
        ? dispatch(updatePatients({ ...patient, remindAlerts: [...patient.remindAlerts, ...alerts], [alertsOrRemind]: [] }))
        : dispatch(updatePatients({ ...patient, [alertsOrRemind]: [] }))
      toggleModal(false)
    }
    catch (err) {
      console.log('error marking alerts', err)
    }
  }
 
  return (
    <Modal
      className={`alerts-modal modal-dialog-${isRealtime ? 'bottom modal-overlay-none' : 'centered'}`} size="md"
      isOpen={alerts && true}
      toggle={() => toggleModal(undefined)}
    >
      <div className="modal-header">
        <Row style={{ display: 'flex', justifyContent: 'flex-start', }}>
          <div style={{ fontSize: 20, marginLeft: 25, marginTop: 20, color: '#060606' }} >Name</div>
          <div style={{ fontSize: 20, marginTop: 20, color: '#1D3378', fontWeight: '500', marginLeft: 15 }}>{patient?.firstName} {patient?.lastName}</div>
          <div style={{ fontSize: 20, marginLeft: 25, marginTop: 20, color: '#060606' }}>ID</div>
          <div style={{ fontSize: 20, marginTop: 20, color: '#1D3378', fontWeight: '500', marginLeft: 15 }}>{patient?.idNumber}</div>
          <div style={{ marginLeft: 25, width: 450, border: '1px solid #003F7B', marginTop: 20 }}></div>
        </Row>
      </div>
      <div className="modal-body" style={{ paddingTop: '0px' }}>
        <div>
          {alerts && alerts.map(alert =>
            <Row key={alert.alertId} className="mt-2">
              <Col xl="1">
                <img className="status" src={Alerton} alt='alert' />
              </Col>
              <Col xl="5">
                {moment(alert.alertDate).format('lll')}
              </Col>
              <div >
                {alert.alertType === 'PPG AF' ? `AF Detected` : alert.alertType}
              </div>
              <Col xl="2">
                {alert.alertType !== 'PPG AF' && fixNumAndRemoveDecimalZero(alert.value, 1)}
              </Col>
              {alert.alertType === 'PPG AF' &&
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                  <div className="rounded-circle" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px', width: '30px', color: '#EF3054', border: '1px solid #EF3054' }} >
                    AF
                  </div>
                </div>}
            </Row>
          )}
        </div>
      </div>
      <div style={{ marginLeft: 25, width: 450, border: '1px solid #003F7B', marginTop: 20 }}></div>
      <div className="modal-footer">
        <Button style={{ width: 260, height: 54, color: '#000000', fontSize: 20, fontWeight: '500', border: '2.5px solid #3873AE', borderRadius: 30, textAlign: 'center' }}
          type="button"
          onClick={() => onConfirm('remind_later')}>
          <img src={Bell} alt='Bell' style={{ marginRight: 10 }} />
          Remind me later
        </Button>
        <Button style={{ width: 144, height: 54, color: '#ffffff', fontSize: 20, marginLeft: 30, fontWeight: '500', backgroundColor: '#2F659C', borderRadius: 30, textAlign: 'center' }}
          type="button"
          onClick={() => { onConfirm('closed') }}>
          Checked
        </Button>
      </div>
    </Modal>
  )
}
